import {
    IonPage, IonContent, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import "./H5Pay.css"
import {appleH5Pay} from "./Service";
import {getQueryVariable} from "../../utils/commonFunction";

class H5Pay extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isH5: true,
            isShowPay: false,
            payStatus: null,
            payOrderId: null,
            payAmount: 0,
            showTipMsg: null,
            isShowTip: false,
            htmlString: null
        }
    }

    componentDidMount() {
        let pm = getQueryVariable('pm');
        if (pm != null) {
            this.jumpNext(pm);
        } else {
            this.setState({
                isShowTip: true,
                showTipMsg: '请勿非法访问'
            })
        }
    }

    jumpNext = (pm) => {
        const {isH5} = this.state;
        const urlParams = {
            'pm': pm
        }
        appleH5Pay(urlParams, isH5).then(ret => {
            if (ret.code === '10000') {
                console.log(ret)
                const d = ret.data;
                if (d.orderStatus !== null && d.orderStatus !== "") {
                    this.setState({
                        payStatus: d.orderStatus,
                        payOrderId: d.orderNum,
                        payAmount: d.payAmount,
                        isShowPay: true
                    })
                } else {
                    if (d.payType === 17) {
                        this.setState({htmlString: d.orderResult})
                        this.aliPaySubmit();
                    } else {
                        window.location.href = d.orderResult;
                    }
                }
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err)
        });
    }

    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null,
            isPicShow: false,
            picNum: 0,
        })
    }

    aliPaySubmit = () => {
        let round = 1;
        let myVal = setInterval(function () {
            //支付宝Md5或RSA加签下单返回方式
            if (document.getElementById('alipaysubmit') !== null ) {
                clearInterval(myVal);
                document.forms['alipaysubmit'].submit();
            }
            if (document.getElementById('form1') !== null ) {
                clearInterval(myVal);
                document.forms['form1'].submit();
            }
            //支付宝RSA2加签下单返回方式
            if (document.getElementsByName('punchout_form') !== null ) {
                clearInterval(myVal);
                document.forms['punchout_form'].submit();
            }
            if (round > 20) {
                clearInterval(myVal);
            }
            round++;
        }, 200)
    }

    render() {
        return (
            <IonPage>
                <meta name="viewport"
                      content="width=device-width, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0"/>
                <meta name="format-detection" content="telephone=no"/>
                <meta name="apple-mobile-web-app-capable" content="yes"/>
                <meta name="apple-mobile-web-app-status-bar-style" content="black"/>
                <IonContent fullscreen>
                    {this.state.isShowPay &&
                        <div className="productbox">
                            <div className="top">
                                <h3>帐号充值-安全支付</h3>
                            </div>
                            <div className="productbox">
                                <ul>
                                    <li><span className="label">订单状态：</span><span
                                        className="value">{this.state.payStatus}</span></li>
                                    <li><span className="label">充值订单号：</span><span
                                        className="value">{this.state.payOrderId}</span></li>
                                    <li><span className="label">充值金额：</span><span
                                        className="value">￥{this.state.payAmount}</span></li>
                                </ul>
                            </div>
                        </div>
                    }
                    <div dangerouslySetInnerHTML={{__html: this.state.htmlString}}/>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(H5Pay);
